export class ContractCommissionRule {
	public contractId: string;
	public upfrontPercentage: number;
	public upfrontLag: number;
	public monthlyLag: number;
	public upfrontDateType: number;
	public hasAnniversaryUpfront: boolean;
	public anniversaryUpfrontDateType: number;
	public minUpfrontTermFactor: number;
	public maxUpfrontTermFactor: number;
	public hasResidentialUpfront: boolean;
	public residentialPayLag: number;
	public residentialResidualLag: number;
	public residentialPayAmount: number;
	public residentialMargin: number;
	public discountFactor: number;
	public maxAdvanceMonths: number;
	public maxUpfrontAmount: number;
	public maxUpfrontAnnualUsage: number;
	public residentialResidualAmount: number;
	public lagCutOffDay: number;
	public anniversaryLag: number;
	public residualFactor: number;
	public acceptsResidentialRenewals: boolean;
	public residentialRenewalPayLag: number;
	public residentialRenewalResidualLag: number;
	public residentialRenewalUpfrontAmount: number;
	public residentialRenewalResidualAmount: number;
	public residentialRenewalMargin: number;
	public residentialRenewalWindow: number;
	public hasRenewalUpfront: boolean;
	public payableUpfrontAmount: number;
	public payableMargin: number;
	public payableResidualAmount: number;
	public payableRenewalUpfrontAmount: number;
	public payableRenewalMargin: number;
	public payableRenewalResidualAmount: number;
	public isManualEdit: boolean;

	constructor(contractCommissionRule: ContractCommissionRule) {
		Object.assign(this, contractCommissionRule);
	}
}
